
export interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

/**
 * Tabs component - Reusable tab navigation component
 * 
 * Features:
 * - Active tab highlighted
 * - Inactive tabs with hover states
 * - Responsive: tabs scroll horizontally on mobile if needed
 * - Accessible: keyboard navigation support
 */
export const Tabs = ({ tabs, activeTab, onTabChange }: TabsProps) => {
  return (
    <div className="border-b border-border overflow-x-auto">
      <div className="flex min-w-max">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`
                px-6 py-3 text-base font-medium transition-colors whitespace-nowrap
                border-b-2
                ${isActive
                  ? 'border-primary text-primary'
                  : 'border-transparent text-text-secondary hover:text-text-primary hover:border-border'
                }
              `}
              aria-selected={isActive}
              role="tab"
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

